import Vue from "vue";
import { getDefaultState } from "./state";
import { IS_VENDOR_OPEN } from "../../../../app-constants";

export function setVendorsList(state, collection) {
  state.vendorsList = (collection || []).map((vendor) => {
    /**
     * @todo move isOpen property to mapper
     */

    // added new prop just for open or closed, default is open, hours code will run and reset it if needed.
    return Object.assign({}, vendor, { [IS_VENDOR_OPEN]: true });
  });
}

export const updateVendor = (state, vendor) => {
  const storedVendorIndex = state.vendorsList.findIndex((storedVendor) => storedVendor.id == vendor.id);
  if (storedVendorIndex !== -1) {
    const storedVendor = state.vendorsList[storedVendorIndex];
    state.vendorsList[storedVendorIndex] = Object.assign({}, vendor, { pickupTimes: storedVendor.pickupTimes });
  }
};

export const updateVendorPickupTimes = (state, { vendorId, pickupTimes }) => {
  const vendor = state.vendorsList.find((storedVendor) => storedVendor.id === +vendorId);

  if (vendor) {
    vendor.pickupTimes = pickupTimes;
  }
};

export function setActiveVendor(state, vendor) {
  state.activeVendor = vendor;
  state.activeVendorId = vendor.id;
}

export function setVendorPickupTimeForDebug(state, { id, time }) {
  const vendor = state.vendorsList.find((vendor) => vendor.id === id);
  if (!vendor.pickupTimes) {
    vendor.pickupTimes = [];
  }
  const existingTimes = vendor.pickupTimes.find((pickupTime) => pickupTime === time);
  if (!vendor || existingTimes?.length) return;

  vendor.pickupTimes.push(time);
}

export function setVendorPickupTimeSelectionEnabled(state, { id, status }) {
  const vendor = state.vendorsList.find((vendor) => vendor.id === id);
  if (vendor) vendor.pickupTimeSelectionEnabled = status;
}

export function setVendorStatus(state, { id, status }) {
  const vendor = state.vendorsList.find((vendor) => vendor.id === id);
  if (vendor) vendor[IS_VENDOR_OPEN] = status;
}

export function setSubvendorList(state, { data }) {
  const list = {};
  if (data.subvendors && data.subvendors.length) {
    data.subvendors.forEach((subvendor) => {
      list[subvendor.id] = subvendor;
    });
    state.subVendorList = list;
  }
}

export function resetState(state) {
  Object.assign(state, getDefaultState());
}

export function resetActiveVendor(state) {
  state.activeVendor = null;
  state.activeVendorId = 0;
}

export function resetVendorLists(state) {
  state.vendorsList = null;
  state.subVendorList = null;
}
